<template>
    <div class="flex flex-wrap justify-start items-center w-full">
      <base-dblclick-input
        modelType="contactClientRelationship"
        :model-id="clientContact.id"
        field-name="email_address"
        :field-value="clientContact.email_address"
        :canCopy="true"
        inputType="text"
        @refetch="fetchNewClients"
      >

      
      <slot name="icon">
      </slot>
      </base-dblclick-input>

    </div>
</template>

<script setup>
import { computed, defineProps, defineEmits } from "vue";
import {formatDate} from '@/composables/formatDate';

const props = defineProps(['clientContact'])

const emit = defineEmits(['refetch-clients'])

function fetchNewClients () {
    emit('refetch-clients')
}

const formattedVerifiedDate = computed(() => {
    try {
      return formatDate(`${props.clientContact.verified_date}`)
    } catch {
      return '--'
    }
  })

</script>